import React, { PureComponent } from 'react';

import { connect } from 'react-redux';

import { Commit } from 'src/components/types';
import { RouteComponentProps } from 'src/router/types';
import { withRouter } from 'src/router/utils';
import { FileMeta } from 'src/sections/repository/sections/source/types';
import { Ref } from 'src/sections/repository/types';
import { getCurrentRepositoryFullSlug } from 'src/selectors/repository-selectors';
import { BucketState } from 'src/types/state';
import urls from 'src/urls/source';

import CommitSelector from '../components/commit-selector';
import FileHistoryProvider, {
  RenderProps,
} from '../components/file-history-provider';

const COMMITS_PAGE_LEN = 10;

type Props = RouteComponentProps & {
  currentHash: string | undefined;
  currentRef: Ref | undefined;
  fileMeta: FileMeta;
  isReadyToFetch: boolean;
  path: string;
  repositoryFullSlug: string | undefined;
};

const mapStateToProps = (state: BucketState) => {
  const { atRef, hash, ref } = state.repository.source.section;
  const { meta } = state.repository.source.file;

  return {
    currentHash: hash,
    currentRef: atRef || ref,
    fileMeta: meta,
    isReadyToFetch: !!meta,
    repositoryFullSlug: getCurrentRepositoryFullSlug(state),
  };
};

export default withRouter(
  connect(mapStateToProps)(
    class FileCommitSelector extends PureComponent<Props> {
      handleOnChange = (commit: Commit) => {
        const { currentRef, path, repositoryFullSlug } = this.props;

        if (!repositoryFullSlug) {
          return;
        }

        const url = urls.ui.source(repositoryFullSlug, {
          refOrHash: commit.hash,
          path,
          at: currentRef ? currentRef.name : undefined,
        });
        this.props.history.push(url);
      };

      render() {
        const {
          currentHash,
          currentRef,
          fileMeta,
          isReadyToFetch,
          repositoryFullSlug,
        } = this.props;

        const historyBaseHash = currentRef
          ? currentRef.target.hash
          : currentHash;

        if (
          !repositoryFullSlug ||
          !historyBaseHash ||
          !fileMeta ||
          !fileMeta.attributes ||
          fileMeta.attributes.includes('subrepository')
        ) {
          return null;
        }

        return (
          <FileHistoryProvider
            pageLen={COMMITS_PAGE_LEN}
            path={this.props.path}
            refOrHash={historyBaseHash}
            repositoryFullSlug={repositoryFullSlug}
            isReadyToFetch={isReadyToFetch}
            render={(fileHistoryProps: RenderProps) => (
              <CommitSelector
                commits={fileHistoryProps.commits}
                hasMore={fileHistoryProps.hasMore}
                isLoading={fileHistoryProps.isLoading}
                onChange={this.handleOnChange}
                onLoadMore={fileHistoryProps.loadMore}
                selectedHash={currentHash}
              />
            )}
          />
        );
      }
    }
  )
);
